import React from "react";
import { Card, CardContent, Typography, Box, Chip, Stack } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

export default function ReviewCustomerSummary({ customer = {} }) {
  const {
    firstName = "",
    lastName = "",
    email = "",
    phone = "",
    phoneSecondary = "",
    phoneSecondaryLabel = "Backup",
    marketingOptIn = false,
  } = customer || {};

  const hasPrimary = !!String(phone).trim();
  const hasBackup = !!String(phoneSecondary).trim();

  return (
    <Card variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
      <CardContent sx={{ p: 2.25 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Customer
        </Typography>

        <Box sx={{ mt: 1, display: "grid", rowGap: 0.75 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <PersonIcon fontSize="small" />
            <Typography variant="body2">
              {firstName} {lastName}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <EmailIcon fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              {email}
            </Typography>
          </Stack>

          {hasPrimary && (
            <Stack direction="row" spacing={1} alignItems="center">
              <PhoneIphoneIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {phone}
              </Typography>
              <Chip size="small" label="Primary" variant="outlined" />
            </Stack>
          )}

          {hasBackup && (
            <Stack direction="row" spacing={1} alignItems="center">
              <PhoneIphoneIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {phoneSecondary}
              </Typography>
              <Chip
                size="small"
                label={phoneSecondaryLabel || "Backup"}
                variant="outlined"
              />
            </Stack>
          )}

          {marketingOptIn && (
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ mt: 0.5 }}>
              <MarkEmailReadIcon fontSize="small" />
              <Chip
                size="small"
                color="primary"
                variant="outlined"
                label="Email updates opted-in"
              />
            </Stack>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
